/* eslint-disable import/prefer-default-export */
import { gql } from "@apollo/client";

export const USER_FIELDS = gql`
  fragment NoteForReviewData on Note {
    id
    FK_Place
    Key
    FK_Bill
    ActivityCode
    SellCondition
    EmitedDay
    InternConsecutive
    Exchange
    ReferenceCode
    ReferenceReason
    FK_AcceptanceState
    BillFlowType
    FK_OwnerPlace
    FK_ReferencedElectronicBill
    AcceptanceDate
    FK_PaymentElectronicDocument
    FK_DocumentAcceptance
    BaseTax
    Factor
    PlatformExchange
    Created_At
    Updated_At
    TotalGoodsExonerated
    Discount
    TotalExempt
    TotalExonerated
    TotalGoodsExempt
    TotalGoodsTaxed
    TotalNetSell
    TotalSell
    TotalServicesExempt
    TotalServicesExonerated
    TotalServicesTaxed
    TotalTaxed
    TotalTaxes
    TotalBill
    SubTotal_Bill
    SellConditionMH {
      id
      Name_SellCondition
    }
    PaymentMethodMH {
      id
      Name_PaymentMethod
    }
    Coin {
      id
      Buy_Coin
      Code_Coin
      Name_Coin
      Sell_Coin
      Symbol_Coin
      Updated_At
      Created_At
    }
    User {
      Person {
        Name_Person
        Lastname_Person
        id
      }
    }
    ElectronicBillDocumentType {
      id
      Description
    }
    Place {
      id
      Name_Place
      Code
      Company {
        id
        Name_Company
        Description_Company
        User {
          id
          UserBillingProfile {
            Name
            ComercialName
            Email
            ID_Number
            PhoneNumber
            OtherSigns
            MH_Province {
              Name
            }
            MH_Canton {
              Name
            }
            MH_District {
              Name
            }
            MH_Neighborhood {
              Name
            }
          }
        }
      }
    }
    NoteDetails {
      id
      Quantity
      FK_ProductFeature
      UnitPrice
      Total_BillDetail
      discount_BillDetail
      ProductFeature {
        id
        Product {
          id
          Name_Product
          Description_Product
        }
      }
    }
  }
`;
